<template>
    <div>
        <div v-for="(itemChanged, index) in itemsChanged" :key="index" style="margin-top: 20px;" class="col-12">
            <div class="container-history">
                <div class="header-card col-12">
                    <div>
                        <span class="title-card-history"> {{ itemChanged }} </span>
                        <span class="subtitle-card-history"> {{ titleDate }} </span>
                    </div>
                    <div class="point-container">
                        <img v-if="upOrDown(itemChanged) === 'down'" style=" height: 11px;margin-left: 7px;"
                            src="../../assets/img/icons/arrow-up.svg" alt="">
                        <img v-if="upOrDown(itemChanged) === 'up'" style=" height: 11px;margin-left: 7px;"
                            src="../../assets/img/icons/arrow-down.svg" alt="">
                        <span class="point"> {{ calcDiffBetweenValues(itemChanged) }}</span>
                    </div>
                </div>

                <div class="col-10 content-card-history">
                    <span class="content-card-text"> {{ itemChanged }} {{ principalMessage(itemChanged) }} </span>
                </div>

                <div class="card-divider"></div>

                <div class="col-12 footer-card-history">
                    <span :class="`footer-score-${upOrDown(itemChanged)}`">o score {{ diffMessageScore(itemChanged) }}
                        {{ calcDiffBetweenValues(itemChanged) }} pontos</span>
                    <span class="footer-point"> {{ scoreAtual | toFixed }} </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
const highlighIsValid = {
    id: false,
    seller_id: false,
    avg_ticket: true,
    created_at: false,
    refund_fee: true,
    avg_sales_risk_score: true,
    updated_at : false,
    total_score: false,
    chargedback_fee: true,
    sales_frequency: true,
    relationship_time: true,
    payment_method_fee: true,
    avg_sales_distance_from_seller: true,
    percentage_sales_refused_fraud: true,
    percentage_sales_refused_invalid_data: true,
    percentage_sales_refused_insufficient_funds: true
}

const keysToString = {
    avg_ticket: 'Ticket médio',
    avg_sales_risk_score: 'Pontuação média de risco de vendas',
    refund_fee: 'Taxa de reembolso',
    total_score: 'Score',
    chargedback_fee: 'Taxa de Chargeback',
    sales_frequency: 'Frequência de vendas',
    relationship_time: 'Tempo de relacionamento',
    payment_method_fee: 'Taxa de Forma de pagamento',
    avg_sales_distance_from_seller: 'Distância média de vendas do vendedor',
    percentage_sales_refused_fraud: 'Vendas recusadas por fraude',
    percentage_sales_refused_invalid_data: 'Vendas recusadas por dados inválidos',
    percentage_sales_refused_insufficient_funds: 'Vendas recusadas por saldo insuficiente'
}

const stringToKey = {
    'Ticket médio': 'avg_ticket',
    'Pontuação média de risco de vendas': 'avg_sales_risk_score',
    'Taxa de reembolso': 'refund_fee',
    'Score': 'total_score',
    'Taxa de Chargeback': 'chargedback_fee',
    'Frequência de vendas': 'sales_frequency',
    'Tempo de relacionamento': 'relationship_time',
    'Taxa de Forma de pagamento': 'payment_method_fee',
    'Distância média de vendas do vendedor': 'avg_sales_distance_from_seller',
    'Vendas recusadas por fraude': 'percentage_sales_refused_fraud',
    'Vendas recusadas por dados inválidos': 'percentage_sales_refused_invalid_data',
    'Vendas recusadas por saldo insuficiente': 'percentage_sales_refused_insufficient_funds',
}
export default {
    filters: {
        toFixed(val) {
            return val ? val.toFixed(1) : 0
        }
    },
    props: ['history'],
    data() {
        return {
            moment: moment
        }
    },
    computed: {
        itemsChanged() {
            let itemsChanged = [];
            Object
                .keys(this.history.model.changes)
                .map(item => {
                    if (
                        highlighIsValid[item] 
                        && this.history.model.original[item] !== null
                        && (this.history.model.current[item] !== this.history.model.original[item])
                        ) itemsChanged.push(keysToString[item])
                })
            return itemsChanged;
        },
        titleDate() {
            return this.moment(this.history.model.current.updated_at).format('DD/MM/YYYY [às] HH:mm')
        },
        scoreAtual() {
            return this.history.model.original.total_score
        }
    },
    methods: {
        upOrDown(itemChanged) {
            const key = stringToKey[itemChanged];
            const original = this.history.model.original[key] || 0;
            const current = this.history.model.current[key] || 0;
            
            if (current > original) {
                return 'up'
            }
            if (original > current) {
                return 'down'
            }
            return ''
        },
        principalMessage(itemChanged) {
            let time = this
                        .moment(this.history.model.original.updated_at)
                        .locale('pt-br')
                        .fromNow()
            return `${this.diffMessage(itemChanged)} ${this.calcDiffBetweenValues(itemChanged)} pontos nos últimos${time.replace('há', '')}`
            
        },
        diffMessage() {
            const original = this.history.model.original.total_score || 0;
            const current = this.history.model.current.total_score || 0;
            if (current < original) {
                return 'aumentou'
            }
            if (original < current) {
                return 'diminuiu'
            }
            return 'não mudou'
        },
        diffMessageScore() {
            const original = this.history.model.original.total_score || 0;
            const current = this.history.model.current.total_score || 0;
            if (current < original) {
                return 'diminuiu'
            }
            if (original < current) {
                return 'aumentou'
            }
            return 'não mudou'
        },
        calcDiffBetweenValues(itemChanged) {
            const key = stringToKey[itemChanged];
            const original = this.history.model.original[key] || 0;
            const current = this.history.model.current[key] || 0;
            let calc = current - original;
            
            if (calc < 0) {
                calc = calc.toFixed(1) * -1; 
            } else {
                calc = calc.toFixed(1); 
            }
            
            return calc;
        }
    }
}
</script>

<style scoped>
    .container-history {
        width: 650px;
        height: 150px;
        border: 0.5px solid #E5E7E8;
        border-radius: 5px;
    }
    .header-card { 
        display: flex; 
        flex-wrap: nowrap; 
        justify-content: space-between; 
        width: 100%;
        padding-top: 15px;
        padding-left: 25px;
    }
    .title-card-history {
        min-width: 350px;
        font-family: 'Montserrat';
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 17px;
        color: #000;
        letter-spacing: 0.2px;
    }
    .subtitle-card-history {
        margin-left: 12px;
        font-family: 'Montserrat';
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 17px;
        color: #81858E;
        letter-spacing: 0.2px;
    }
    .point-container {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        min-width: 57px;
        height: 26px;
        border: 0.5px solid #E5E7E8;
        border-radius: 5px;
    }
    .point {
        margin-right: 8px;
        margin-left: 7px;
        font-family: Montserrat;
        font-size: 13px;
        font-weight: 400;
        line-height: 16px;
        color: #81858E;
        text-align: left;
        letter-spacing: 0.2px;
    }
    .content-card-history {
        height: 60px;
        padding-top: 15px;
        padding-left: 25px;
    }
    .content-card-text {
        font-family: Montserrat;
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
        color: #81858E;
        text-align: left;
        letter-spacing: 0.2px;
    }
    .card-divider {
        height: 1px; 
        margin-top: 10px; 
        margin-bottom: 11px; 
        border-top: 0.5px solid #E5E7E8;
    }
    .footer-card-history { 
        display: flex;
        justify-content: space-between; 
        min-height: 30px; 
        padding-right: 25px; 
        padding-bottom: 15px;
        padding-left: 25px;
    }
    .footer-score-down {
        padding-left: 7px;
        font-family: Montserrat;
        font-size: 13px;
        font-weight: 400;
        line-height: 16px;
        color: #81858E;
        letter-spacing: 0.2px;
        border-left: 2px solid #04D43F;
    }
    .footer-score-up {
        padding-left: 7px;
        font-family: Montserrat;
        font-size: 13px;
        font-weight: 400;
        line-height: 16px;
        color: #81858E;
        letter-spacing: 0.2px;
        border-left: 2px solid #F41A42;
    }
    .footer-point {
        font-family: Montserrat;
        font-size: 13px;
        font-weight: 600;
        line-height: 16px;
        color: #000;
        text-align: right;
        letter-spacing: 0.2px;
    }
</style>